import { createBrowserHistory } from 'history';

// export const history = createBrowserHistory({ basename: '/backoffice' });
export const history = createBrowserHistory();